import { FormControl } from '@angular/forms';

export function ValidateId(c: FormControl) {
	// let id = c.value;

	// if (typeof id !== "string"){
	// 	id = String(id);
	// }

	// if (id.length == 0) return;
	
	// if (isNaN(id) || Number(id) === 0){
	// 	return { 
	// 		invalidId: true 
	// 	}; // not a number - not valid
	// }

	// // while (id.length < 9) {
	// // 	id = '0' + id;
	// // }

	// let digits = id.split("");

	// digits = digits.map(function (digit, index) {
	// 	if (index % 2 == 0) {
	// 		return digit;
	// 	} else {
	// 		digit = digit * 2;

	// 		if (digit > 9){
	// 			return (digit % 10) + 1;
	// 		}

	// 		return digit;
	// 	}
	// });

	// let sum = digits.reduce(function (a, b) {
	// 	return Number(a) + Number(b);
	// });

	// return sum % 10 === 0 ? null : { invalidId: true };
	let Str_obj = c.value;
	var i,max,flag=2,character,sum = 0,a,Strid,Numid;
	Numid = new Number(Str_obj);
   
	if (isNaN(Numid))
	{  
		return { invalidId: true };
	}

	Strid = new String(Str_obj);
	max = Strid.length;
	for (i=max;i<11;i++)
	{
		Strid = "0" + Strid;
	}
	 
	for (i=0;i<11;i++)
	{ 
		if (flag==1) 
		{
			flag =2;
		}
		else 
		{   
			flag =1;
		}
		character=parseInt(Strid.charAt(i));
		a = flag * character;
		if (a> 9)
		{
			a = a -9;
		}
		sum = sum + a;   
	}

	if (sum == 0)
		return { invalidId: true };
	
	if (sum%10 != 0) 
	{
		return { invalidId: true };
	}
	else
	{
		return null;
	}   

}


// WEBPACK FOOTER //
// ./src/app/id-validator.ts